import { provide, inject, type ModelRef } from 'vue';

const SIDE_PANEL_CONTROLLER_KEY = Symbol('sidePanelController');

interface SidePanelController {
    open: () => void;
    close: () => void;
    toggle: () => void;
    state: ModelRef<boolean>;
}

export function useSidePanelProvider(state: ModelRef<boolean>): SidePanelController {
    if (!state) {
        throw new Error('Trying to create a side panel provider without a model value.');
    }
    const controller = {
        open: () => {
            state.value = true;
        },
        close: () => {
            state.value = false;
        },
        toggle: () => {
            state.value = !state.value;
        },
        state,
    };
    provide(SIDE_PANEL_CONTROLLER_KEY, controller);
    return controller;
}

export function useSidePanel(): SidePanelController {
    const sidePanelController = inject(SIDE_PANEL_CONTROLLER_KEY);
    if (!sidePanelController) throw new Error('Calling useSidePanel outside of PSidePanel');
    return sidePanelController as SidePanelController;
}
